/**
 * NOS-118: AI profile settings page — view/edit org AI profile.
 * Requires can_manage_settings permission.
 */
import { Link, Navigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { PermissionGate } from "@/components/PermissionGate"
import { OrgAIProfileForm } from "@/components/settings/OrgAIProfileForm"
import { useOrgAIProfile } from "@/hooks/useOrgAIProfile"

export function OrgProfilePage() {
  const { profile, isLoading, error, updateProfile } = useOrgAIProfile()

  return (
    <PermissionGate permission="can_manage_settings" fallback={<Navigate to="/dashboard" replace />}>
      <div className="min-h-screen bg-background">
          <header className="border-b px-4 py-4">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-semibold text-charity-forest">
                AI Profile
              </h1>
              <Button variant="outline" size="sm" asChild>
                <Link to="/dashboard/settings">Back to settings</Link>
              </Button>
            </div>
          </header>

          <main className="p-4 sm:p-6">
            <Card>
              <CardHeader>
                <CardTitle>Organization AI Profile</CardTitle>
                <CardDescription>
                  This profile helps AI features (content generation, section rewrites) personalize
                  copy for your organization. Edit and save to keep it up to date.
                </CardDescription>
              </CardHeader>
              <CardContent>
                {error && (
                  <p className="text-sm text-destructive mb-4">{error}</p>
                )}
                <OrgAIProfileForm
                  profile={profile}
                  isLoading={isLoading}
                  onSave={updateProfile}
                />
              </CardContent>
            </Card>
          </main>
        </div>
    </PermissionGate>
  )
}
